"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _filterDOMProps = _interopRequireDefault(require("../../utils/filterDOMProps"));

var _Heading = _interopRequireDefault(require("../../Heading"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/
if (process.env.SCALE_MEDIUM && process.env.SCALE_LARGE) {
  require("../../spectrum-css/illustratedmessage/index.css");

  require("../../spectrum-css/illustratedmessage/index-diff.css");
} else if (process.env.SCALE_LARGE) {
  require("../../spectrum-css/illustratedmessage/index-lg.css");
} else {
  require("../../spectrum-css/illustratedmessage/index.css");
}

if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHT) require("../../spectrum-css/illustratedmessage/multiStops/light.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARK) require("../../spectrum-css/illustratedmessage/multiStops/dark.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHTEST) require("../../spectrum-css/illustratedmessage/multiStops/lightest.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARKEST) require("../../spectrum-css/illustratedmessage/multiStops/darkest.css");

/**
 * An IllustratedMessage displays an illustration icon and a message, usually in an empty state or on an error page.
 */
var IllustratedMessage =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(IllustratedMessage, _React$Component);

  function IllustratedMessage() {
    (0, _classCallCheck2["default"])(this, IllustratedMessage);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(IllustratedMessage).apply(this, arguments));
  }

  (0, _createClass2["default"])(IllustratedMessage, [{
    key: "isIllustrationDecorative",
    value: function isIllustrationDecorative() {
      var _this$props = this.props,
          illustration = _this$props.illustration,
          heading = _this$props.heading,
          description = _this$props.description;

      if (illustration) {
        var props = illustration.props;
        var ariaLabel = props['aria-label'],
            ariaLabelledby = props['aria-labelledby'],
            ariaHidden = props['aria-hidden']; // If illustration is explicitly hidden for accessibility return the ariaHidden value.

        if (ariaHidden != null) {
          return ariaHidden;
        } // If illustration is explicitly labelled using aria-label or aria-labelledby return null.


        if (ariaLabel || ariaLabelledby) {
          return false;
        }
      } // Otherwise, assume the image is decorative.


      return !!(heading || description);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          _this$props2$illustra = _this$props2.illustration,
          illustration = _this$props2$illustra === void 0 ? null : _this$props2$illustra,
          className = _this$props2.className,
          heading = _this$props2.heading,
          description = _this$props2.description,
          ariaLevel = _this$props2.ariaLevel,
          otherProps = (0, _objectWithoutProperties2["default"])(_this$props2, ["illustration", "className", "heading", "description", "ariaLevel"]);

      if (illustration && (!illustration.props.className || !illustration.props.className.includes('spectrum-IllustratedMessage-illustration'))) {
        illustration = _react["default"].cloneElement(illustration, {
          className: (0, _classnames["default"])(illustration.props.className, 'spectrum-IllustratedMessage-illustration'),
          'aria-hidden': this.isIllustrationDecorative() || null
        });
      }

      return _react["default"].createElement("div", (0, _extends2["default"])({}, (0, _filterDOMProps["default"])(otherProps), {
        className: (0, _classnames["default"])('spectrum-IllustratedMessage', className)
      }), illustration, heading && _react["default"].createElement(_Heading["default"], {
        variant: "pageTitle",
        className: "spectrum-IllustratedMessage-heading",
        "aria-level": ariaLevel
      }, heading), description && _react["default"].createElement("p", {
        className: "spectrum-Body--secondary spectrum-IllustratedMessage-description"
      }, description));
    }
  }]);
  return IllustratedMessage;
}(_react["default"].Component);

exports["default"] = IllustratedMessage;
(0, _defineProperty2["default"])(IllustratedMessage, "propTypes", {
  /** The heading to be displayed */
  heading: _propTypes["default"].string,

  /** The description to be displayed */
  description: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),

  /** The illustration to be rendered above heading. Should be an SVG element. */
  illustration: _propTypes["default"].element,

  /** The heading level for the heading element to preserve hierarchy of headings in web page for accessibility. */
  ariaLevel: _propTypes["default"].number
});
(0, _defineProperty2["default"])(IllustratedMessage, "defaultProps", {
  heading: null,
  description: null
});